import { Controller } from '@hotwired/stimulus';

// Debounced email-availability check used on the BD payment page to
// stop a guest from paying for a subscription their email already owns.
// Backed by GET /subscriptions/bd/subscriber_check.
export default class extends Controller {
  static targets = ['input', 'error', 'submit'];
  static values = {
    url: String,
    debounce: { type: Number, default: 500 }
  };

  connect() { this._timer = null; }

  disconnect() {
    if (this._timer) clearTimeout(this._timer);
  }

  check() {
    if (this._timer) clearTimeout(this._timer);
    this._timer = setTimeout(() => this._fetch(), this.debounceValue);
  }

  _fetch() {
    const email = this.hasInputTarget ? this.inputTarget.value.trim() : '';
    if (!email || email.indexOf('@') === -1) {
      this._setAvailable(true, '');
      return;
    }

    fetch(`${this.urlValue}?email=${encodeURIComponent(email)}`, {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then((response) => response.json())
      .then((data) => this._setAvailable(data.available !== false, data.message || ''))
      .catch(() => this._setAvailable(true, '')); // network errors don't block
  }

  _setAvailable(available, message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message;
      this.errorTarget.hidden = available;
    }
    this.submitTargets.forEach((btn) => {
      btn.disabled = !available;
      btn.classList.toggle('is-disabled', !available);
    });
  }
}
